export type MenuDisplayMode = "overlay" | "bottom" | "left";

/**
 * Resolve how the device menu should be displayed, from `device.menu.displayMode`.
 * Header and App both depend on this, so keep the rules in one place.
 * @param deviceData Device document content
 * @param deviceMenu Menu entries built by Menu.tsx (may contain holes for unpublished items)
 * @returns Display mode, or null when there are too few items to show a menu
 */
export const getMenuDisplayMode = (deviceData: any, deviceMenu: any): MenuDisplayMode | null => {
  const itemCount = deviceMenu?.filter(Boolean)?.length || 0;
  if (itemCount < 2) { return null; }

  const mode = deviceData?.menu?.displayMode;

  if (mode === "left") {
    // A sidebar leaves too little room for content in portrait
    return window.innerWidth > window.innerHeight ? "left" : "overlay";
  }

  if (mode === "bottom") { return "bottom"; }

  return "overlay";
};
